import { supabase } from './supabase';
import type { Payslip } from '../types/payslip';
import { PostgrestError } from '@supabase/supabase-js';
import thirstyLogo from '../../assets/thirsty-logo.png';

export const fetchPayslips = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from('payslips')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data as Payslip[];
  } catch (error) {
    console.error('Error fetching payslips:', error);
    return [];
  }
};

export const fetchPayslipById = async (id: string) => {
  try {
    const { data, error } = await supabase
      .from('payslips')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as Payslip;
  } catch (error) {
    console.error('Error fetching payslip:', error);
    return null;
  }
};

// For admin use - create/update payslips
export const upsertPayslip = async (payslip: Omit<Payslip, 'id' | 'created_at'>) => {
  try {
    console.log('Attempting to upsert payslip:', payslip);
    
    const { data, error } = await supabase
      .from('payslips')
      .upsert(
        {
          user_id: payslip.user_id,
          period: payslip.period,
          daily_rate: payslip.daily_rate,
          total_hours: payslip.total_hours,
          overtime_hours: payslip.overtime_hours,
          basic_pay: payslip.basic_pay,
          holiday_pay: payslip.holiday_pay,
          incentives: payslip.incentives,
          other_bonuses: payslip.other_bonuses,
          total_gross: payslip.total_gross,
          sss: payslip.sss,
          pagibig: payslip.pagibig,
          philhealth: payslip.philhealth,
          ca: payslip.ca,
          loan_deduction: payslip.loan_deduction,
          other_deductions: payslip.other_deductions,
          total_deductions: payslip.total_deductions,
          net_pay: payslip.net_pay,
          updated_at: new Date().toISOString()
        },
        {
          onConflict: 'user_id,period'
        }
      );

    if (error) {
      console.error('Supabase error:', error);
      throw error;
    }

    console.log('Payslip upserted successfully:', data);
    return data;
  } catch (error) {
    console.error('Error upserting payslip:', error);
    throw error;
  }
}; 